const EMBEDDED_DATA_IMAGE_URL_RE = /^data:image\/[a-z0-9.+-]+;base64,[a-z0-9+/=\s]+$/i;
/**
 * Returns true when the URL is an embedded base64-encoded image.
 *
 * We use this to selectively allow Google Docs / KB imported inline images
 * without broadly permitting arbitrary `data:` URLs.
 */
export function isEmbeddedDataImageUrl(url) {
    return EMBEDDED_DATA_IMAGE_URL_RE.test(url.trim());
}
/**
 * Produces a short, readable preview for huge base64 image URLs so UIs can
 * show that an embedded image was parsed successfully without dumping the full
 * payload into the page.
 */
export function getEmbeddedDataImagePreview(url) {
    const trimmed = url.trim();
    const marker = ";base64,";
    const markerIndex = trimmed.indexOf(marker);
    if (markerIndex === -1) {
        return trimmed;
    }
    return `${trimmed.slice(0, markerIndex + marker.length)}...`;
}
